import { BaseResponse } from './base-response.model';
import { FileUtility } from '../utility/file.utility';

export interface ReportHistoryResonse extends BaseResponse {
	message: string;
	history: ReportHistoryJSON[];
}

export interface ReportHistoryJSON {
	id: number;
	reportScheduleId: number;
	reportId: number;
	reportName: string;
	filename: string;
	fileCreateDttm: string;
	fileFormat: string;
	fileSize: number;
	fileVersion: number;
	scheduleUpdatedBy: string;
	scheduleUpdateUserId: number;
}

export class ReportHistory {
	constructor(
		public id: number,
		public reportScheduleId: number,
		public reportId: number,
		public reportName: string,
		public filename: string,
		public fileCreateDttm: string,
		public fileFormat: string,
		public fileSize: number,
		public fileVersion: number,
		public scheduleUpdatedBy: string,
		public scheduleUpdateUserId: number,
		public file: Blob
	) {}

	static fromJSON(json: ReportHistoryJSON): ReportHistory {
		return Object.assign(Object.create(ReportHistory.prototype), json, {
			file: null,
		});
	}

	static addFile(file: Blob, report: ReportHistory): ReportHistory {
		return Object.assign(Object.create(ReportHistory.prototype), report, {
			file: file,
		});
	}

	open(): void {
		if (this.file && this.filename) {
			FileUtility.open(this.file, this.filename);
		}
	}
}
